<ng-container>
  <mat-tab-group class="sub-tab-group" animationDuration="0ms" disableRipple="true">
    <mat-tab label="campus">
      <ng-template mat-tab-label>
        <span class="gl-mat-tab-label"> Campus </span>
      </ng-template>
      <ng-template matTabContent>
        <ng-container *ngTemplateOutlet="ssoConfigTemplate; context: { sid: sids.campus }"></ng-container>
      </ng-template>
    </mat-tab>

    <mat-tab *ngIf="client?.productivityCfg?.roleplay?.enabled" label="roleplay">
      <ng-template mat-tab-label>
        <span class="gl-mat-tab-label"> Roleplay IA </span>
      </ng-template>
      <ng-template matTabContent>
        <ng-container *ngTemplateOutlet="ssoConfigTemplate; context: { sid: sids.roleplay }"></ng-container>
      </ng-template>
    </mat-tab>

    <mat-tab *ngIf="client?.productivityCfg?.kepler?.enabled" label="kepler">
      <ng-template mat-tab-label>
        <span class="gl-mat-tab-label"> Kepler </span>
      </ng-template>
      <ng-template matTabContent>
        <ng-container *ngTemplateOutlet="ssoConfigTemplate; context: { sid: sids.kepler }"></ng-container>
      </ng-template>
    </mat-tab>

    <mat-tab *ngIf="client?.productivityCfg?.mars?.enabled" label="mars">
      <ng-template mat-tab-label>
        <span class="gl-mat-tab-label"> Mars </span>
      </ng-template>
      <ng-template matTabContent>
        <ng-container *ngTemplateOutlet="ssoConfigTemplate; context: { sid: sids.mars }"></ng-container>
      </ng-template>
    </mat-tab>

    <mat-tab label="sftp">
      <ng-template mat-tab-label>
        <span class="gl-mat-tab-label"> SFTP </span>
      </ng-template>
      <ng-template matTabContent>
        <lms-client-sftp-editor [client]="client"></lms-client-sftp-editor>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</ng-container>

<ng-template #ssoConfigTemplate let-sid="sid">
  <lms-client-sso-editor
    [client]="client"
    [sid]="sid"
    [ssoConfig]="ssoConfigMap[sid]"
    (saved)="onSaved($event)"
  ></lms-client-sso-editor>
</ng-template>
